import React from 'react';
import { Shield, User } from 'lucide-react';

/**
 * Sélecteur de type de client (Professionnel / Particulier)
 */
const ClientTypeSelector = ({ clientType, setClientType }) => {
  return (
    <section className="card client-type-card" data-testid="client-type-section">
      <h2 className="section-title">Type de Client</h2>
      <div className="client-type-toggle-container">
        <button
          className={`client-type-toggle-btn ${clientType === 'pro' ? 'active' : ''}`}
          onClick={() => setClientType('pro')}
          data-testid="client-pro-btn"
        >
          <Shield size={24} />
          <span>Professionnel</span>
        </button>
        <button
          className={`client-type-toggle-btn particulier ${clientType === 'particulier' ? 'active' : ''}`}
          onClick={() => setClientType('particulier')}
          data-testid="client-particulier-btn"
        >
          <User size={24} />
          <span>Particulier</span>
        </button>
      </div>
    </section>
  );
};

export default ClientTypeSelector;
